import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { decodeJWT } from '../utils/jwt';
import { useAtom } from 'jotai';

import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  CircularProgress,
  Link,
  Snackbar,
  Alert,
} from '@mui/material';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import userAtom from '../atoms/auth/UserAtoms';
import axiosInstance from '../utils/axios';
import LoginContainer from './LoginContainer';

function Login() {
  const navigate = useNavigate();
  const [, setUser] = useAtom(userAtom);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setBtnLoading(true);
      setLoading(true);

      const tempData = {
        email: email.toLowerCase(),
        password: password,
      };

      const loginResp = await axiosInstance.post(`/auth/login`, tempData);

      if (loginResp.status === 200) {
        const decoded = decodeJWT(loginResp.data["access_token"]);
        Cookies.set("access_token", loginResp.data["access_token"], {
          expires: new Date(decoded.exp * 1000),
        });
        Cookies.set("refresh_token", loginResp.data["refresh_token"], {
          expires: new Date(decoded.exp * 1000),
        });
        localStorage.setItem("Theme", 'light');
        localStorage.setItem("project_permissions", JSON.stringify(loginResp.data.project_permissions));
        localStorage.setItem("user_auth_id", loginResp?.data?.user?.id);

        setSnackbar({
          open: true,
          message: "Login successful!",
          severity: "success",
        });

        if (loginResp?.data?.user?.last_login === null) {
          setUser({ loggedIn: false, data: decoded });
          navigate("/auth/reset");
        } else {
          setUser({ loggedIn: true, data: decoded });
          setTimeout(() => {
            window.location.href = "/";
          }, 1000);
        }
      } else {
        setSnackbar({
          open: true,
          message: "Something went wrong!",
          severity: "error",
        });
      }
    } catch (err) {
      console.error("Invalid-Credentials", err);
      setSnackbar({
        open: true,
        message: "Invalid email or password!",
        severity: "error",
      });
    } finally {
      setLoading(false);
      setBtnLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#f5f5f5',
      }}
    >
      <LoginContainer />
      <Box
        component="form"
        onSubmit={onSubmit}
        sx={{
          width: 432,
          p: 4,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          // boxShadow: 3,
        }}
      >
        <Box sx={{ mb: 5, textAlign: 'start' }}>
          <img src="/suryalogo.svg" alt="Surya Logo" width={230} height={50} />
        </Box>

        <TextField
          fullWidth
          label="Email ID"
          type="email"
          placeholder="jhon@surya123"
          variant="outlined"
          required
          value={email}
          onChange={handleEmailChange}
          sx={{ mb: 3 }}
        />

        <TextField
          fullWidth
          label="Password"
          type={showPassword ? 'text' : 'password'}
          placeholder="Enter Password"
          variant="outlined"
          required
          value={password}
          onChange={handlePasswordChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ mb: 2 }}
        />

        <Box sx={{ textAlign: 'right', mb: 3 }}>
          <Link
            component="a"
            variant="body2"
            onClick={() => navigate("/forgot-password")}
            underline="hover"
            style={{ cursor: 'pointer' }}
          >
            Forgot Password?
          </Link>
        </Box>

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ height: 59, borderRadius: '30px', fontSize: "20px", fontWeight: 600 }}
          disabled={btnLoading}
        >
          {btnLoading ? <CircularProgress size={24} color="inherit" /> : "Log in"}
        </Button>

        {/* <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center' }}>
          <Button
            startIcon={<PhoneIphoneIcon sx={{ transform: 'rotate(270deg)' }} />}
            onClick={() => window.location.replace("https://tablet.suryaweb.app/install")}
            color="inherit"
            sx={{ textDecoration: 'underline', textTransform: 'none' }}
          >
            Download Tablet App
          </Button>
        </Box> */}
      </Box>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default Login;
